export const MOBILE_QUERY: string = '(max-width: 768px)';

/** Sidebar widths (rem, so they scale with the root font size like the rest of the layout) */
export const SIDEBAR_WIDTH_DESKTOP = '13.125rem';
export const SIDEBAR_WIDTH_TABLET = '3.75rem';
